import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Badge, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";

const Campaign = () => {
    const {t,i18n} = useTranslation()
    const location = useLocation()

	useEffect(() => {
		document.querySelector("title").textContent = "投稿企画 - アワートAI"
	},[location.pathname])

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Container className='mt-3 mb-3'>
            <h3>第1回イラストコンテスト開催のお知らせ</h3>
            <p>
                当サイト初となるイラストコンテストを開催します！<br />
                手書き部門とAI部門で行います。<br />
                期間中に投稿されたいいねの数をイラスト毎に評価します。最優秀賞はAmazonギフト券5000円分。<br />
                さらに、いいねをつけた閲覧者からも抽選で3名にAmazonギフト券1000円分が当たります。<br />
                <a href="https://twitter.com/ourt_official/status/1596981874496516098">告知ツイート</a>をリツイートしていただけると嬉しいです！
                <br />
                <br />
                手書き部門は<a href="https://ourt.work/">ourt</a>へ、<br />
                AI部門は当サイトへ投稿ください。
            </p>
            <h3>テーマ</h3>
            <p><del>「冬」、「クリスマス」、「年末年始」</del><br />
            ※より多くご投稿いただくために、テーマは自由としました。
            </p>
            <h3>開催期間</h3>
            <p>2022/11/29～<del>2023/1/8</del>2023/3/10</p>
            <h3>参加条件</h3>
            <ul style={{listStyleType:"decimal"}}>
                <li>ユーザ登録し、イラストを投稿</li>
                <li>投稿画面または閲覧画面からイラストをツイート</li>
                <li>禁止事項(共通)
                    <ul style={{listStyleType:"decimal"}}>
                        <li>他のコンテストなどに応募したものの投稿。</li>
                        <li>自分自身が作成していないものの投稿。</li>
                        <li>他者が権利を持つものの投稿。</li>
                        <li><Link to='/terms'>利用規約</Link>に違反する行為。</li>
                    </ul>
                </li>
                <li>禁止事項(手書き部門)
                    <ul style={{listStyleType:"decimal"}}>
                        <li>AIで加筆修正を行ったものの投稿。</li>
                    </ul>
                </li>
                <li>禁止事項(AI部門)
                    <ul style={{listStyleType:"decimal"}}>
                        <li>人が加筆修正を行ったものの投稿。</li>
                        <li>txt2img以外で作成された写真やイラストをもととするimg2img生成のイラストの投稿。</li>
                        <li>img2img生成もとのtxt2imgイラストが、投稿者以外が生成したものを使用したものの投稿。</li>
                    </ul>
                </li>
                <li>その他
                    <ul style={{listStyleType:"decimal"}}>
                        <li>投稿数に制限はありません。</li>
                        <li>1投稿につき1枚であること。</li>
                        <li>手書き部門、AI部門は両方に参加できます。</li>
                        <li>使用したプロンプト、ネガティブプロンプトの公開は必須です。(AI部門)</li>
                        <li>参加する場合は概要にハッシュタグ「#第1回アワートイラストコンテスト参加作品」と、<br />
                            部門別のタグを追加してください。<br />
                            手書き部門「#イラコン手書き部門」<br />
                            AI部門「#イラコンAI部門」
                        </li>
                    </ul>
                </li>
            </ul>
            <h3>結果について</h3>
            <p>
                入賞した場合の連絡については2023年1月以降、WebサイトやSNSでの発表と、受賞者にDMを送ります。<br />
                連絡可能なSNSのID(TwitterIDなど)を設定から記載いただくとスムーズです！<br />
            </p>
            <p>
                ※状況に応じて内容が変更される場合があります
            </p>
        </Container>
        <hr />
        <Container className='mt-3 mb-3'>
            <h3>【2022/11/1】 イラスト投稿企画のお知らせ</h3>
            <p>
                期間中にイラストを投稿していただいた方の中から、抽選で3名にAmazonギフト券3000円分を進呈します！
            </p>
            <h3>開催期間</h3>
            <p>2022/11/1～2022/11/30</p>
            <h3>参加条件</h3>
            <ul style={{listStyleType:"decimal"}}>
                <li>抽選条件：11/30までに以下の条件を満たすこと</li>
                <li>ユーザ登録の完了</li>
                <li>イラストを投稿</li>
                <li>閲覧画面のツイートボタンから投稿をツイート</li>
                <li><a href='https://twitter.com/ourt_official/status/1587425825573720066' target="_blank" rel="noreferrer">この投稿</a>をリツイート</li>
            </ul>
            <h3>抽選結果について</h3>
            <p>
                抽選結果は12月以降当選者にDMにてお知らせします。<br />
                ユーザ登録時、TwitterIDを記載いただくとスムーズです！<br />
                ※Twitterアカウントで登録した場合は自動でIDも登録されます。
            </p>
        </Container>
        <Footer />
    </div>
    )
}

export default Campaign;
